import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { listControls } from '../Api'

export default generateApiAction({
  baseType: Types.CONTROLS.LIST,
  api: listControls,
  responseType: RESPONSETYPE.DATA
})



// WEBPACK FOOTER //
// ./src/actions/controls/ListAction.js